var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 8H46.4584V47.5833H15.2084V8Z",
    fill: "#7CCC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 44.4583H14.1667C11.8677 44.4583 10 42.5907 10 40.2917C10 37.9927 11.8677 36.125 14.1667 36.125H19.375V39.25H14.1667C13.5929 39.25 13.125 39.7179 13.125 40.2917C13.125 40.8654 13.5929 41.3333 14.1667 41.3333H15.2083V44.4583Z",
    fill: "#7DEBF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 31.9583H14.1667C11.8677 31.9583 10 30.0907 10 27.7917C10 25.4927 11.8677 23.625 14.1667 23.625H19.375V26.75H14.1667C13.5929 26.75 13.125 27.2179 13.125 27.7917C13.125 28.3654 13.5929 28.8333 14.1667 28.8333H15.2083V31.9583Z",
    fill: "#7DEBF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 20.5H14.1667C11.8677 20.5 10 18.6323 10 16.3333C10 14.0343 11.8677 12.1666 14.1667 12.1666H19.375V15.2916H14.1667C13.5929 15.2916 13.125 15.7596 13.125 16.3333C13.125 16.907 13.5929 17.375 14.1667 17.375H15.2083V20.5Z",
    fill: "#7DEBF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 36.125H19.375V39.25H15.2084V36.125Z",
    fill: "#3CC0D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 23.625H19.375V26.75H15.2084V23.625Z",
    fill: "#3CC0D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 12.1666H19.375V15.2916H15.2084V12.1666Z",
    fill: "#3CC0D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5834 21.5416H39.1667V29.875H24.5834V21.5416Z",
    fill: "#329F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.981b1170c318cfc7847a819279c9b971.svg";
export { ForwardRef as ReactComponent };